<base-site-layout
    [heading]="'Vergabeverzicht' | translate"
    headerIcon="fas fa-file-signature"
    [isDialog]="true"
    (dialogCloseClicked)="close()"
>
    <div class="row mb-3">
        <div class="col">
            <div class="alert alert-warning mb-0">
                <em class="fas fa-triangle-exclamation pe-2"></em>
                {{
                    'Für diesen Warenkorb liegen Angebote oberhalb des Wertlimits von {{priceLimit}} {{currency}} mit weniger als {{minOffers}} vergleichbaren Angeboten vor. Bitte begründen Sie den Vergabeverzicht, um die Bestellung auszulösen.'
                        | translate
                            : {
                                  priceLimit: data.check.priceLimit,
                                  currency: data.check.currencyCode,
                                  minOffers: data.check.minimumNumberOfOffers,
                              }
                }}
            </div>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col">
            <text-module-selection
                [category]="TextModuleCategoryEnum.SOURCING_WAIVER"
                [formControl]="justificationControl"
                [title]="'Vergabeverzicht (Begründung)' | translate"
                [markRequired]="true"
            ></text-module-selection>
        </div>
    </div>
    <div class="row justify-content-end">
        <div class="col-auto">
            <button type="button" class="btn btn-outline-dark me-2" (click)="close()">
                {{ 'Abbrechen' | translate }}
            </button>
            <button
                type="button"
                class="btn btn-success"
                [disabled]="justificationControl.invalid"
                (click)="save()"
            >
                <em class="fas fa-cart-shopping px-1"></em>
                {{ 'Bestellung auslösen' | translate }}
            </button>
        </div>
    </div>
</base-site-layout>
